/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Style */
import './FocusableEditUnratedContentProfile.scss';

function EditUnratedContent({
  className,
  focused,
  checked,
}) {
  return (
    <div className={`dtv-html5-c-edit-unrated-content ${className} ${focused ? 'dtv-html5-c-edit-unrated-content--focused' : ''}`}>
      <div className="">
        <p id="dtv-html5-c-edit-unrated-content_unrated-content-label">
          <FormattedMessage id="profiles.parentalControl.content.without.classification" />
        </p>
      </div>
      <div className="dtv-html5-c-edit-unrated-content_unrated-content-toogle">
        <FormattedMessage id="profiles.parentalControl.allowed" />
        <div className="switch">
          <input type="checkbox" readOnly checked={checked} />
          <span className={`slider round ${checked ? 'checked' : ''}`}>{checked}</span>
        </div>
      </div>
    </div>
  );
}

EditUnratedContent.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
};

EditUnratedContent.defaultProps = {
  className: '',
  focused: false,
};

export default memo(withInteractiveFocusable()(memo(EditUnratedContent)));
